<template>
  <div id="pageContent">
    <div class="borderBox">

      <detailWin v-if="showDetail" v-on:closeDetails="closeDetails()" :DemandID="DemandID" :type="1"></detailWin>


      <div  class="headFinder fl">


        <div class="input_box fl">
          <div>
            <label  class="left">Поиск по таблице</label>
            <div class="fl">
              <input type="text" v-model="searchValue">
              <div class="button" v-on:click="find()">Найти</div>
            </div>
          </div>
        </div>


      </div>

      <div>
        <ul id="result_table" class="finderRequest myrequest">
          <li id="result_head">
            <p>Номер заявки</p>
            <p>Дата подачи заявки</p>
            <p>ФИО клиента</p>
            <p>Дата рождения клиента</p>
            <p>Дата и время отправки смс</p>
            <p>Тип обзвона</p>
          </li>
          <li
              class="fl"
              v-for="(item, index) in filteredList"
              :key="index"
              v-on:click="showDetail = true; DemandID = item.demandID "
              :class="issetCssClass(item)"
          >
            <p>{{ item.demandID }}</p>
            <p>{{ $myFilter.timeFromXtoDateView(item.demandDate) }}</p>
            <p>{{ item.clientFIO }}</p>
            <p>{{ $myFilter.timeFromXtoDateView(item.clientBirthDate) }}</p>
            <p>{{ $myFilter.timeFromXtoDateView3(item.smsDateTime) }}</p>
            <p>{{ item.typeName }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "online",
  data() {
    return {
     searchValue: '',
      filteredList: [],
      showDetail: false,
      list: [],
      DemandID: 0
    }
  },
  methods: {
    issetCssClass(obj) {
      // v-bind:class="{ mobileShow: moreFlag, selectedLineStyle: select }"
      if (obj.cssClassName !== undefined) {
        return obj.cssClassName
      } else {
        return false
      }
    },
    closeDetails() {
      this.showDetail = false;
      this.getSimpleDemandsNotReady();
    },
    find() {
      console.log('find');
      this.filteredList = [];
      if (this.searchValue.length === 0) {
        this.filteredList = this.list;
      }
      let indexOf = ''
      for (let i = 0; i <this.list.length; i++) {
        let string = ''
        for (let key in this.list[i]) {
          let listItem = this.list[i][key]
          if (typeof(listItem) === 'string') {
            listItem = this.list[i][key].toLowerCase()
          }
          string += (' ' + listItem);
        }
        this.list[i]['filter'] = string;
        indexOf = this.list[i]['filter'].indexOf(this.searchValue);
        console.log(indexOf);
        if (indexOf > 0) {
          this.filteredList.push(this.list[i])
        }
      }
    },
    getSimpleDemandsNotReady() {
      this.$myApi.callSharpApi({
        externalType: 'ms',
        msUrl: 'back-loannp/CallCenter/CC_SimpleDemandsNotReady',
        urlType: '',
        method: 'GET',
        UserID: localStorage.getItem('UserID'),
      }).then((res) => {
        for ( let key in res) {
          if ( res[key].typeID !== undefined && res[key].typeID !== null) {
            switch (res[key].typeID) {
              case 189: res[key]['cssClassName'] = 'hasNoActivity'; break;
              case 188: res[key]['cssClassName'] = 'noReaction'; break;
              default: break;
            }
          }
        }
        this.list = res;
        this.filteredList = this.list;
        console.log(res);
      }).catch(res => {
        console.log(res);
      })
    },


    confirmLeave() {
      return window.confirm('ВНИМАНИЕ! Вы пытаетесь перейти на предыдущую страницу. Если в данный момент Вы находитесь в таблице заявок, то можете нажать "Да". Если вы находитесь в режиме редактирования заявки ( открыто окно детализации ), то переход на предыдущую страницу оставит заявку заблокированной за Вами, что не позволит другим пользователям редактировать её. Нажмите "Нет", чтобы вернуться к редактированию. Закройте окно детализации, нажав на крестик в верхнем правом углу окна детализации чтобы корректно разблокировать заявку. Вы хотите перейти на предыдущую страницу?');
    },

    beforeWindowUnload(e) {
      if (this.confirmLeave()) {
        // Cancel the event
        e.preventDefault()
        // Chrome requires returnValue to be set
        e.returnValue = ''
      }
    },

  },
  mounted() {
    this.getSimpleDemandsNotReady();
  },


  beforeRouteLeave (to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (!this.confirmLeave()){
      next(false)
    } else {
      // Navigate to next view
      next()
    }
  },

  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload)
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload)
  },





  components: {
    formInput: () => import('@/components/forms/formInput'),
    detailWin: () => import('@/views/detailsWindow'),
  }
}
</script>

<style scoped>
.borderBox{ width: 1600px }
.button {display: flex; align-items: center; margin: 0 0 10px 0}
.headFinder{align-items: center;}
#result_table li{display: flex;align-items: stretch;justify-content: start;border:1px solid #c2c2c2;background: rgba(217, 243, 220, 0.52);font-size: 14px;line-height: 1.1;text-transform: lowercase; cursor: pointer}
#result_table li:nth-child(2n){background: white;}
#result_table li p{border-left: 1px solid #c2c2c2;padding: 4px;}
#result_table li p:first-child{border-left: 0 solid #c2c2c2;}

#result_table li.hasNoActivity{background: #fdffcccc}
#result_table li.noReaction{background: #3db04a70}

#result_table.finderRequest p:nth-child(1){width: 7%;}
#result_table.finderRequest p:nth-child(2){width: 12%;}
#result_table.finderRequest p:nth-child(3){width: 8%;}
#result_table.finderRequest p:nth-child(4){width: 8%;}
#result_table.finderRequest p:nth-child(5){width: 8%;}
#result_table.finderRequest p:nth-child(6){width: 8%;}
#result_table.finderRequest p:nth-child(7){width: 8%;}
#result_table.finderRequest p:nth-child(8){width: 8%;}
#result_table.finderRequest p:nth-child(9){width: 7%;}
#result_table.finderRequest p:nth-child(10){width: 16%;}

#result_table.finderRequest.myrequest p:nth-child(1){width: 10%;}
#result_table.finderRequest.myrequest p:nth-child(2){width: 10%;}
#result_table.finderRequest.myrequest p:nth-child(3){width: 10%;}
#result_table.finderRequest.myrequest p:nth-child(4){width: 10%;}
</style>

